"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldGroupNav = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formContext = require("./form-context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FieldGroupsComponent = function FieldGroupsComponent(_ref) {
  var onClickGroup = _ref.onClickGroup,
      props = _objectWithoutProperties(_ref, ["onClickGroup"]);

  var api = (0, _react.useContext)(_formContext.ContextApi);
  (0, _react.useContext)(_formContext.ContextForm);

  if (!api) {
    console.error("Could not found Form API. Make sure <FieldGroups/> is in the <Form/>.");
    return null;
  }

  var _api$getClasses = api.getClasses('fieldGroup'),
      errors = _api$getClasses.errors,
      active = _api$getClasses.active,
      touched = _api$getClasses.touched,
      completed = _api$getClasses.completed;

  return _react["default"].createElement("ul", props, api.getGroups().map(function (group) {
    var _classNames;

    return _react["default"].createElement("li", {
      key: group.name,
      className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, errors, group.hasErrors), _defineProperty(_classNames, active, group.isActive), _defineProperty(_classNames, touched, group.isTouched), _defineProperty(_classNames, completed, group.isCompleted), _classNames)),
      onClick: function onClick() {
        if (onClickGroup) {
          onClickGroup(group);
        }
      }
    }, group.name);
  }));
};

FieldGroupsComponent.displayName = 'FieldGroups';
var FieldGroupNav = FieldGroupsComponent;
exports.FieldGroupNav = FieldGroupNav;